/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Admin_Shared_Time_Ago_In_MinutesInputs */

const en_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}m ago`)
};

const de_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vor ${i?.minutes}m`)
};

const es_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`hace ${i?.minutes}m`)
};

const fr_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`il y a ${i?.minutes}m`)
};

const it_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}m fa`)
};

const pt_br2_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`há ${i?.minutes}m`)
};

const pl_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes}m temu`)
};

const hu_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} perce`)
};

const ro_admin_shared_time_ago_in_minutes = /** @type {(inputs: Admin_Shared_Time_Ago_In_MinutesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`acum ${i?.minutes}m`)
};

/**
* | output |
* | --- |
* | "{minutes}m ago" |
*
* @param {Admin_Shared_Time_Ago_In_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_shared_time_ago_in_minutes = /** @type {((inputs: Admin_Shared_Time_Ago_In_MinutesInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Shared_Time_Ago_In_MinutesInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "de") return de_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "es") return es_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "fr") return fr_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "it") return it_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "pt-BR") return pt_br2_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "pl") return pl_admin_shared_time_ago_in_minutes(inputs)
	if (locale === "hu") return hu_admin_shared_time_ago_in_minutes(inputs)
	return ro_admin_shared_time_ago_in_minutes(inputs)
});
export { admin_shared_time_ago_in_minutes as "admin.shared.time_ago_in_minutes" }